export default __webpack_public_path__ + "static/media/FCB.8255f47b.gif";